import * as React from 'react';
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {TabPanel} from "../../components/other/tabPanel";
import {DictionariesAdmin} from "./dictionaries/admin_dictionaries";
import {useTranslation} from "react-i18next";
import DicAudit from "./dictionaries/dictionaries_audit";
import NhsUpsertData from "./dictionaries/nhs_upsert_data";
import makeStyles from "@mui/styles/makeStyles";
import {StyledTab, StyledTabs} from "./admin";
import useDict from '../../hooks/useDict';
import useActiveModules from '../centralPage/hooks/useActiveModules';

const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#448FFF"
    }
}));

function Dictionaries(props) {
    const {t} = useTranslation();
    const classes = useStyles();
    const [currentTab, setCurrentTab] = React.useState(props.selectedTab ? props.selectedTab : 0);

    // Load editable collection from db
    const [adminDictionariesEditors, adminDictionariesLoading] = useDict("AdminDictionariesEditors","order,name");

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    React.useEffect(()=>{
        if(props.selectedTab) {
            setCurrentTab(props.selectedTab);
        } else {
            setCurrentTab(0);
        }
    }, [props.selectedTab])

    return (
        <Box sx={{ width: '100%', padding: '0px'}}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
                <StyledTabs value={currentTab} onChange={handleTabChange} aria-label="Dictionaries" TabIndicatorProps={{className: classes.indicator}}>
                    <StyledTab value={0} label={t("Dictionaries")} />
                    <StyledTab value={1} label={t("Dictionaries audit")} />
                    <StyledTab value={2} label={t("NHS Upsert Data")} />
                </StyledTabs>
            </Box>
            <TabPanel value={currentTab} index={0} childSx={{padding: "8px 2px 2px 2px"}}>
                <DictionariesAdmin dictionariesEditors={adminDictionariesEditors}/>
            </TabPanel>
            <TabPanel value={currentTab} index={1} childSx={{padding: "8px 2px 2px 2px"}}>
                <DicAudit/>
            </TabPanel>
            <TabPanel value={currentTab} index={2} childSx={{padding: "8px 2px 2px 2px"}}>
                <NhsUpsertData dictionariesEditors={adminDictionariesEditors}/>
            </TabPanel>
        </Box>)
}

export default Dictionaries;